"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchInventoryToolStore = exports.updateSearchParams = exports.setAllToNull = exports.previouslyViewedHandlerStorage = exports.isElementInView = exports.getPreviousParams = exports.generateDealerUrlWithIntSrc = exports.convertToBoolean = exports.convertBooleanToString = exports.compareVehicleHandlerStorage = exports.arePropsEqual = void 0;
var _zustandBlueprints = require("../../_nextgen/packages/zustand-blueprints");
// biome-ignore lint/suspicious/noExplicitAny: use any to cover all cases
const removeEmptyArrays = function (obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key].length > 0) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};
const searchInventoryToolStore = (0, _zustandBlueprints.createBlueprint)(function (set) {
  return {
    // VLP Filters
    vehicleFilterState: {},
    setVehicleFilterState: function (filterState) {
      return set(function (_ref) {
        let {
          vehicleFilterState
        } = _ref;
        if (typeof filterState === "object") {
          const newObj = filterState;
          return {
            vehicleFilterState: removeEmptyArrays(newObj)
          };
        }
        const setterFn = filterState;
        const newObj = setterFn(vehicleFilterState);
        return {
          vehicleFilterState: removeEmptyArrays(newObj)
        };
      });
    },
    // VLP search params navigation
    vehicleNavigationState: {},
    setVehicleNavigationState: function (navigationState) {
      return set(function (_ref2) {
        let {
          vehicleNavigationState
        } = _ref2;
        if (typeof navigationState === "object") {
          const newObj = navigationState;
          return {
            vehicleNavigationState: removeEmptyArrays(newObj)
          };
        }
        const setterFn = navigationState;
        const newObj = setterFn(vehicleNavigationState);
        return {
          vehicleNavigationState: removeEmptyArrays(newObj)
        };
      });
    },
    // VLP Compare Vehicle
    compareVehicles: [],
    setCompareVehicles: function (vehicles) {
      return set({
        compareVehicles: vehicles
      });
    },
    isFullCompareVehicles: false,
    updateIsFullCompareVehicles: function (isFull) {
      return set({
        isFullCompareVehicles: isFull
      });
    }
  };
});
const useSearchInventoryToolStore = function (_ref3) {
  let {
    id,
    initialValues
  } = _ref3;
  return (0, _zustandBlueprints.useBlueprint)({
    id,
    blueprint: searchInventoryToolStore,
    initialValues: {
      ...initialValues
    }
  });
};
exports.useSearchInventoryToolStore = useSearchInventoryToolStore;
const compareVehicleHandlerStorage = function () {
  let modelName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  const getCompareVehicleListStorage = function () {
    const compareVehicleStorage = sessionStorage.getItem("SIT_COMPARE_VEHICLE_LIST");
    return compareVehicleStorage && JSON.parse(compareVehicleStorage);
  };
  const setCompareVehicleListStorage = function (data) {
    sessionStorage.setItem("SIT_COMPARE_VEHICLE_LIST", JSON.stringify(data));
  };
  const getCompareVehicleModelStorage = function () {
    const compareVehicleStorage = sessionStorage.getItem("SIT_COMPARE_VEHICLE_MODEL");
    return compareVehicleStorage && JSON.parse(compareVehicleStorage);
  };
  const setCompareVehicleModelStorage = function (data) {
    sessionStorage.setItem("SIT_COMPARE_VEHICLE_MODEL", JSON.stringify(data));
  };
  const getCompareVehicleCookieArray = function () {
    const compareVehicleModelCookie = getCompareVehicleModelStorage();
    if (compareVehicleModelCookie !== modelName && modelName !== undefined) {
      setCompareVehicleListStorage([]);
      return [];
    }
    const compareVehicle = getCompareVehicleListStorage();
    const compareVehicleArray = compareVehicle && typeof compareVehicle === "object" && Array.isArray(compareVehicle) ? [...new Set(compareVehicle)] : [];
    return compareVehicleArray;
  };
  const addToCompareVehicleCookie = function (vehicles) {
    if (modelName !== undefined) setCompareVehicleModelStorage(modelName);
    setCompareVehicleListStorage(vehicles);
  };
  return [getCompareVehicleCookieArray, addToCompareVehicleCookie];
};
exports.compareVehicleHandlerStorage = compareVehicleHandlerStorage;
const previouslyViewedHandlerStorage = function (numberPreviouslyViewed) {
  const getPreviouslyViewed = function () {
    const previouslyViewedStorage = localStorage.getItem("SIT_PREVIOUSLY_VIEWED");
    return previouslyViewedStorage && JSON.parse(previouslyViewedStorage);
  };
  const setPreviouslyViewed = function (data) {
    localStorage.setItem("SIT_PREVIOUSLY_VIEWED", JSON.stringify(data));
  };
  const clearPreviouslyViewed = function (previouslyViewed) {
    if (numberPreviouslyViewed && previouslyViewed.length > numberPreviouslyViewed) {
      previouslyViewed.splice(numberPreviouslyViewed, previouslyViewed.length);
    }
    setPreviouslyViewed(previouslyViewed);
    return previouslyViewed;
  };
  const getPreviouslyViewedArray = function () {
    const previouslyViewed = getPreviouslyViewed();
    const previouslyViewedArray = previouslyViewed && typeof previouslyViewed === "object" && Array.isArray(previouslyViewed) ? [...new Set(previouslyViewed)] : [];
    return clearPreviouslyViewed(previouslyViewedArray);
  };
  const vehicleIsOnPreviouslyViewed = function (vin) {
    var _getPreviouslyViewedA;
    const index = (_getPreviouslyViewedA = getPreviouslyViewedArray()) === null || _getPreviouslyViewedA === void 0 ? void 0 : _getPreviouslyViewedA.findIndex(function (i) {
      return i.vin === vin;
    });
    const isOnPreviously = index !== -1;
    return {
      index,
      isOnPreviously
    };
  };
  const addToPreviouslyViewed = function (vehicle) {
    var _vehicle$dealer, _vehicle$dealer2;
    const previouslyViewed = getPreviouslyViewedArray();
    const vehicleClicked = {
      vin: vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin,
      dealer: {
        isSmartPath: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer = vehicle.dealer) === null || _vehicle$dealer === void 0 ? void 0 : _vehicle$dealer.isSmartPath,
        dealerSiteURL: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.dealerSiteURL
      },
      modelUrl: vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelUrl
    };
    const {
      index,
      isOnPreviously
    } = vehicleIsOnPreviouslyViewed(vehicleClicked.vin);
    if (isOnPreviously) {
      previouslyViewed.splice(index, 1);
      previouslyViewed.unshift(vehicleClicked);
    } else {
      previouslyViewed.unshift(vehicleClicked);
    }
    if (numberPreviouslyViewed && previouslyViewed.length > numberPreviouslyViewed) {
      previouslyViewed.pop();
    }
    setPreviouslyViewed(previouslyViewed);
  };
  const removeToPreviouslyViewed = function (vehicles) {
    const previouslyViewed = getPreviouslyViewedArray();
    const removedPreviouslyViewed = previouslyViewed.filter(function (i) {
      return !vehicles.some(function (j) {
        return j.vin === i.vin;
      });
    });
    setPreviouslyViewed(removedPreviouslyViewed);
  };
  return {
    getPreviouslyViewedArray,
    addToPreviouslyViewed,
    vehicleIsOnPreviouslyViewed,
    removeToPreviouslyViewed
  };
};
exports.previouslyViewedHandlerStorage = previouslyViewedHandlerStorage;
const getPreviousParams = function (excludedParams, searchParams) {
  const params = {
    ...searchParams
  };
  const paramsToDelete = Object.keys(params).filter(function (i) {
    return excludedParams.includes(i);
  });
  paramsToDelete.forEach(function (i) {
    return delete params[i];
  });
  return params;
};
exports.getPreviousParams = getPreviousParams;
const clearCodeParams = function (newParams, searchParams) {
  const params = {
    ...searchParams
  };
  if (Object.keys(newParams).length === 0) {
    Object.keys(searchParams).forEach(function (i) {
      if (i.includes("Code")) delete params[i];
    });
    return params;
  }
  const paramsToDelete = Object.keys(newParams).filter(function (i) {
    var _searchParams$i, _newParams$i;
    return Object.keys(searchParams).includes(`${i}Code`) || ((_searchParams$i = searchParams[i]) === null || _searchParams$i === void 0 ? void 0 : _searchParams$i.length) === 1 || ((_newParams$i = newParams[i]) === null || _newParams$i === void 0 ? void 0 : _newParams$i.length) === 0;
  });
  paramsToDelete.forEach(function (i) {
    delete params[i];
    delete params[`${i}Code`];
  });
  return params;
};
const clearEmptyParams = function (searchParams) {
  const params = {
    ...searchParams
  };
  const paramsToDelete = Object.keys(params).filter(function (i) {
    var _searchParams$i2;
    return ((_searchParams$i2 = searchParams[i]) === null || _searchParams$i2 === void 0 ? void 0 : _searchParams$i2.length) === 0;
  });
  paramsToDelete.forEach(function (i) {
    return delete params[i];
  });
  return params;
};
const updateSearchParams = function (excludedParams, searchParams, newParams) {
  let remainPreviousParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  let replaceUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  const previousParams = excludedParams ? getPreviousParams(excludedParams, searchParams) : searchParams;
  const cleanCodeParams = clearCodeParams(newParams, previousParams);
  const cleanEmptyNewParams = clearEmptyParams(newParams);
  if (remainPreviousParams) return {
    search: {
      ...cleanCodeParams,
      ...cleanEmptyNewParams
    },
    resetScroll: false,
    replace: replaceUrl
  };
  return {
    search: {
      ...cleanEmptyNewParams
    },
    resetScroll: false,
    replace: replaceUrl
  };
};
exports.updateSearchParams = updateSearchParams;
const setAllToNull = function (obj) {
  let newObj = {
    ...obj
  };
  if (Array.isArray(obj)) newObj = [...obj];
  for (const prop in newObj) {
    newObj[prop] = null;
  }
  return newObj;
};
exports.setAllToNull = setAllToNull;
const arePropsEqual = function (_name) {
  return function (prevProps, nextProps) {
    const allKeys = Object.keys({
      ...prevProps,
      ...nextProps
    });
    const changes = {};
    let propsAreEqual = true;
    allKeys.forEach(function (key) {
      if (prevProps[key] !== nextProps[key]) {
        changes[key] = {
          from: prevProps[key],
          to: nextProps[key]
        };
        propsAreEqual = false;
      }
    });
    if (Object.keys(changes).length) {
      console.log("Prop changes:", _name, changes);
    }
    return propsAreEqual;
  };
};
exports.arePropsEqual = arePropsEqual;
const isElementInView = function (element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
exports.isElementInView = isElementInView;
const convertToBoolean = function (variable) {
  if (typeof variable === "boolean") {
    return variable;
  }
  if (variable === 1 || (variable === null || variable === void 0 ? void 0 : variable.toLowerCase()) === "true") {
    return true;
  }
  return false;
};
exports.convertToBoolean = convertToBoolean;
const convertBooleanToString = function (variable) {
  if (typeof variable !== "boolean") {
    return variable;
  }
  if (variable) {
    return "true";
  }
  return "false";
};
exports.convertBooleanToString = convertBooleanToString;
const generateDealerUrlWithIntSrc = function (vdpUrl, dealerSiteURL, withIntsrcSearchParams) {
  const baseUrl = vdpUrl || dealerSiteURL;
  return baseUrl ? withIntsrcSearchParams(baseUrl, {
    destination: vdpUrl ? "inventory" : "home",
    dealerPageType: vdpUrl ? "Inventory" : "HomePage"
  }) : undefined;
};
exports.generateDealerUrlWithIntSrc = generateDealerUrlWithIntSrc;